import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { EASE } from "../lib/motion";

export default function ProductCard({ product, big = false }) {
  const save = product.original_price && product.original_price > product.price ? product.original_price - product.price : 0;
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.code}`}
      className={`group relative block overflow-hidden border border-white/[0.08] bg-[#0E1015] hover:border-white/25 transition-colors duration-300 ${big ? "md:col-span-2 md:row-span-2" : ""}`}
    >
      <div className={`overflow-hidden ${big ? "aspect-[4/5] md:aspect-auto md:h-full md:min-h-[560px]" : "aspect-[4/5]"}`}>
        <motion.img
          src={product.image}
          alt={product.title}
          className="w-full h-full object-cover"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.7, ease: EASE }}
        />
      </div>
      {product.tag && (
        <span className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.2em] bg-volt text-void px-2.5 py-1.5 font-bold">
          {product.tag}
        </span>
      )}
      {save > 0 && (
        <span data-testid={`product-save-badge-${product.code}`} className="absolute top-4 right-4 font-mono text-[10px] tracking-[0.2em] bg-acid text-void px-2.5 py-1.5 font-bold">
          SAVE ₹{save.toLocaleString("en-IN")}
        </span>
      )}
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#060709] via-[#060709]/70 to-transparent p-4 pt-14 flex items-end justify-between gap-3">
        <div>
          <h3 className="font-display text-sm md:text-base font-bold uppercase leading-tight">{product.title}</h3>
          <p className="font-mono text-[10px] text-dim tracking-widest mt-1 uppercase">{product.gsm}</p>
        </div>
        <div className="text-right shrink-0">
          <p className="font-mono text-sm font-bold text-acid">₹{product.price.toLocaleString("en-IN")}</p>
          {product.original_price && (
            <p className="font-mono text-[10px] text-mute line-through">₹{product.original_price.toLocaleString("en-IN")}</p>
          )}
        </div>
      </div>
    </Link>
  );
}
